<template>
    <div class="terminos-y-condiciones content-background-2">
        <v-container>
            <v-row class="pa-10">
                
                <v-col cols="12" m="12">
                    <span class="titulos-size bold d-block">Aviso de Privacidad</span>
                    <br>
                    <p class="subtitulo">
                        En cumplimiento a la Ley Federal de Protección de Datos Personales en Posesión de los Particulares (la “Ley”), su reglamento y demás disposiciones que de la misma se desprenden, 
                        EVEN TELECOM, S.A. DE C.V. (en lo sucesivo, “EVEN”), con domicilio en Jimenez, número 490, Colonia Centro,
                         en la ciudad de Monterrey, Nuevo León, C.P. 64000, le informa mediante el presente aviso de privacidad (el “Aviso de Privacidad”) 
                        que es responsable del tratamiento de sus datos personales, su uso y protección; buscando en todo momento evitar daños, pérdida, destrucción, robo, extravío, alteración o tratamientos no autorizados de los mismos.
                    </p>
                </v-col>
                <v-col cols="12" md="12">
                    <span class="titulos-size bold d-block">1.1. Responsabilidad</span>
                    <br>
                    <p class="subtitulo">
                        EVEN, por medio de la persona designada en el inciso 1.10 del presente Aviso de Privacidad, será responsable de recabar sus datos personales, del uso que se le dé a 
                        los mismos y de su protección comprometiéndose a respetar lo establecido en el presente Aviso de Privacidad y en la Ley.
                        <br>
                        <br>
                        EVEN le informa que sus datos personales serán tratados y resguardados con base en los principios de licitud, calidad, consentimiento, información, finalidad, lealtad, 
                        proporcionalidad y responsabilidad, establecidos en la Ley. Al proporcionar datos personales a EVEN por cualquiera 
                        de los medios mencionados en el inciso 1.4 del presente Aviso de Privacidad, usted otorga su consentimiento para 
                        que EVEN recopile y utilice los estos datos únicamente para los fines descritos en el inciso 1.3 del presente Aviso de Privacidad.
                    </p>
                    
                </v-col>
                <v-col cols="12" md="12">
                    <span class="titulos-size bold d-block">1.2 Datos personales a recabar</span>
                    <br>
                    <p class="subtitulo">
                        Derivado de la relación contractual celebrada con usted, EVEN requerirá sus datos personales siguientes: (i) nombre completo, (ii) sexo, (iii) domicilio, (iv) edad y fecha 
                        de nacimiento, (v) estado civil, (vi) Registro Federal de Contribuyentes (RFC), (vii) Clave Única de Registro de Población (CURP), (viii) datos bancarios, 
                        (ix) actividad comercial, (x) información de contacto (teléfono, celular, correo electrónico).
                    </p>
                </v-col>
                <v-col cols="12" md="12">
                    <span class="titulos-size bold d-block">1.3. Finalidad de los Datos Personales</span>
                    <br>
                    <span class="subtitulo d-block">a) Relativas a la relación contractual existente:</span>
                    <br>
                    <span class="subtitulo d-block">(i) Dar cumplimiento a las obligaciones contraídas por EVEN.</span>
                    <br>
                    <span class="subtitulo d-block">
                        (ii) Informarle sobre cualquier circunstancia relacionada con los servicios contratados.
                    </span>
                    <br>
                    <span class="subtitulo d-block">
                        (iii) Presentar los reportes requeridos por la legislación aplicable.
                    </span>
                    <br>
                    <span class="subtitulo d-block">b) Relativas a finalidades adicionales a la relación contractual:
                    </span>
                    <br>
                    <span class="subtitulo d-block">
                        (i) Incluirlo en el padrón de clientes de la empresa.
                    </span>
                    <br>
                    <span class="subtitulo d-block">
                        (ii) Informar a terceros sobre la relación comercial existente.
                    </span>
                    <br>
                </v-col>


                <v-col cols="12" md="12">
                    <span class="titulos-size bold d-block">1.2 Datos personales a recabar</span>
                    <br>
                    <p class="subtitulo">
                        Derivado de la relación contractual celebrada con usted, EVEN requerirá sus datos personales siguientes: (i) nombre completo, (ii) sexo, (iii) domicilio, (iv) edad y fecha 
                        de nacimiento, (v) estado civil, (vi) Registro Federal de Contribuyentes (RFC), (vii) Clave Única de Registro de Población (CURP), (viii) datos bancarios, 
                        (ix) actividad comercial, (x) información de contacto (teléfono, celular, correo electrónico).
                    </p>
                </v-col>
                <v-col cols="12" md="12">
                    <span class="titulos-size bold d-block">1.4. Obtención de Datos Personales</span>
                    <br>
                    <p class="subtitulo">
                        Para dar cumplimiento a los fines señaladas en el punto anterior, 
                        EVEN podrá recabar sus datos personales de distintas formas: (i) cuando se le proporcionen directamente o (ii) cuando se obtenga información a 
                        través de otras fuentes que están permitidas por la Ley.

                    </p>
                </v-col>
                <v-col cols="12" md="12">
                    <span class="titulos-size bold d-block">1.5. Transferencia de Datos</span>
                    <br>
                    <p class="subtitulo">
                        Los datos personales podrán ser transferidos y tratados dentro y fuera del territorio mexicano, por EVEN o personas distintas a ésta. En caso de usted 
                        no manifieste su oposición para que sus datos sean transferidos, se entenderá que ha otorgado su consentimiento para ello. EVEN se compromete a realizar 
                        cualquier transferencia en los términos fijados en este Aviso de Privacidad y en la misma Ley.
                        <br>
                        <br>
                        El tratamiento de los datos personales que se realicen entre EVEN, sus empleados y cualquier abogado o autoridad no requerirá consentimiento adicional alguno.
                    </p>
                </v-col>
                <v-col cols="12" md="12">
                    <span class="titulos-size bold d-block">1.6. Acceso, Rectificación, o Cancelación de datos personales</span>
                    <br>
                    <p class="subtitulo">
                        Usted podrá en cualquier momento corregir o actualizar su información, oponerse al tratamiento que se les esté dando a sus datos personales o revocar el 
                        consentimiento que ha otorgado con la nalidad de que EVEN deje de hacer uso de ellos, en el entendido de que EVEN no queda obligado a cumplir con lo anterior 
                        de conformidad con lo establecido en el artículo 26 y 34 de la Ley.
                        <br>
                        <br>
                        Para revocar el consentimiento otorgado a EVEN sobre los datos personales, usted deberá enviar un correo electrónico Área Responsable de los Datos Personales de EVEN, 
                        conforme a lo señalado en el inciso 1.10 de este documento. El correo electrónico deberá contener (i) el nombre completo del titular de los datos personales; (ii) domicilio 
                        y correo electrónico para recibir la respuesta que se genere con motivo de su solicitud; (iii) el motivo de su solicitud; (iv) los argumentos que sustenten su solicitud o petición; 
                        (v) documento oficial que acredite su identidad; y (vi) fecha a partir de la cual, se hace efectiva la revocación del consentimiento. EVEN le noticará en un plazo máximo de 20 (veinte) 
                        días hábiles, contados desde la fecha en que recibió la solicitud.
                        <br>
                        <br>
                        Para obtener acceso a cualquier información personal o revocar el consentimiento que se le ha otorgado a EVEN, se deberán satisfacer todos los requisitos estipulados en la presente Aviso 
                        de Privacidad y en la Ley.
                    </p>
                </v-col>
                <v-col cols="12" md="12">
                    <span class="titulos-size bold d-block">1.7. Vigencia</span>
                    <br>
                    <p class="subtitulo">
                        EVEN podrá tratar sus datos personales durante el tiempo que dure la relación contractual existente y el plazo legal que se requiera conforme a las leyes aplicables.
                        <br>
                        <br>
                        La obligación de condencialidad de las personas que participan en el tratamiento de los datos personales subsistirá aun después de terminada la relación de éstos con EVEN.
                    </p>
                </v-col>
                <v-col cols="12" md="12">
                    <span class="titulos-size bold d-block">1.8. Modicación al Aviso de Privacidad</span>
                    <br>
                    <p class="subtitulo">
                        EVEN se reserva el derecho para cambiar el presente Aviso de Privacidad en cualquier momento, sin previa noticación ni responsabilidad. En caso de que el Aviso de Privacidad 
                        sea modicado de cualquier manera, EVEN se obliga a darle a conocer su nuevo Aviso de Privacidad mediante el mecanismo de comunicación habituado con usted y a través de su página web.
                        <br>
                        <br>
                        La recolección de información, el uso y la divulgación que haga EVEN de sus datos personales será regida por la versión del Aviso de Privacidad que en ese momento esté vigente.

                    </p>
                </v-col>
                <v-col cols="12" md="12">
                    <span class="titulos-size bold d-block">1.9. Seguridad</span>
                    <br>
                    <p class="subtitulo">
                        EVEN se compromete a que los datos personales serán resguardados bajo estrictas medidas de seguridad administrativas, técnicas y físicas las cuales han sido implementadas con el 
                        objeto de proteger los datos personales contra daño, pérdida, alteración, destrucción o el uso, acceso o tratamiento no autorizado.
                        <br>
                        <br>
                        Únicamente el personal autorizado por EVEN, tendrá acceso a los datos personales. El personal autorizado tiene prohibido permitir el acceso de personas no autorizadas y utilizar 
                        los datos personales para nes distintos a los establecidos en la presente cláusula.
                    </p>
                </v-col>
                <v-col cols="12" md="12">
                    <span class="titulos-size bold d-block">1.10. Responsable de los Datos Personales</span>
                    <br>
                    <p class="subtitulo">
                        EVEN designa al Área Responsable de los Datos Personales como responsable del tratamiento de sus datos personales en la compañía. Usted podrá comunicarse con dicha área mediante 
                        el correo electrónico datospersonales@eventelecom.com.mx, el teléfono (81) 19 69 66 70 o directamente en la dirección establecida en el presente Aviso de Privacidad.

                    </p>
                </v-col>
                <v-col cols="12" md="12">
                    <span class="titulos-size bold d-block">Aviso de Privacidad - Correo Electrónico</span>
                    <br>
                    <p class="subtitulo">
                        La comunicación electrónica es confidencial, privilegiada y no podrá ser divulgada sin la autorización previa de Even Telecom. No está permitido el acceso, la distribución, 
                        copia ni divulgación por cualquier persona diferente a Even Telecom. Si por error ha recibido esta comunicación, por favor notifíquenoslo de inmediato por esta misma vía y 
                        destruya este mensaje. El presente documento no constituye un ofrecimiento ni la aceptación de un acuerdo comercial, por lo que cualquier trato que pudiera existir entre nosotros 
                        deberá en todo caso constar por escrito y ser firmado por ambos. En Even Telecom nos hemos esforzado para que el presente mensaje se encuentre libre de virus o malware, sin embargo no
                         podemos garantizarlo, por lo que en ningún caso nos haremos responsables por algún daños o pérdida que surja por la recepción, apertura o uso de este correo o los documentos que, en su 
                         caso, se incluyan en el mismo.

                    </p>
                </v-col>
                <v-col cols="12" md="12">
                    <span class="titulos-size bold d-block">Privacy policy – email</span>
                    <br>
                    <p class="subtitulo">
                        The electronic communication is confidential, privileged and may not be disclosed without our prior consent. Access to this communication by any person other than the recipient is not permitted 
                        and the distribution, copying or disclosure thereof is strictly prohibited. If you have accidentally received this communication, please notify me immediately and destroy this message. This document 
                        does not constitute an offer or the acceptance of a trade agreement, so any agreement that might exist between us must be in writing and signed by both parties. Although, in Even Telecom we have made 
                        efforts to ensure that this message is free of viruses and other malware, but we can ́t guarantee this, therefore in no case we will be liable for any damages or losses arising from the receipt, 
                        opening or use of this communication or the documents herein attached.

                    </p>
                </v-col>
                <v-col cols="12" md="12">
                    <span class="titulos-size bold d-block"></span>
                    <br>
                    <p class="subtitulo">
                        

                    </p>
                </v-col>

            </v-row>
        </v-container>
    </div>
</template>
<script>
export default {
  name: 'App',

  components: {
  },

  data: () => ({
    //

    aviso:{}
  }),
  mounted: function(){
    fetch('https://nncms.actstudio.xyz/api/singletons/get/Terminos?token=8cf7ca41761951fdde0c1e2cfda401')
    .then(data => data.json())
    .then(data => this.aviso = data);
  }
};
</script>
